import { r as registerInstance, h, H as Host } from './index-5faac9d7.js';
import { q as parseJSONString } from './index-e29b327a.js';
import { a as state } from './store-22db8dad.js';
import './currency-7be6806c.js';
import './lodash-bd96d09c.js';
import './_commonjsHelpers-11ca3be1.js';
import './analytics-205f1857.js';
import './_nodeUtil-f95b2b52.js';
import './_Stack-68736bd1.js';
import './index-54dd34b7.js';

const appPlaygroundCss = ".app-playground__range-title{font-weight:normal}@media screen and (max-width: 979px){.app-playground__range-title{font-size:18px;line-height:25px}}@media screen and (min-width: 980px){.app-playground__range-title{font-size:22px;line-height:30px}}";

const AppPlayground = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.showPanel = window.location.search.indexOf('hide-panel=true') === -1;
    this.updateCount = 0;
    this.productIdToShow = undefined;
    state.on('set', () => this.updateCount++);
  }
  didCCDialogClosed() {
    this.productIdToShow = undefined;
  }
  get pesApp() {
    return h("slot", { name: "pes-app" });
  }
  get app() {
    switch (state.get('appType')) {
      case 'commerceConnector':
        return (h("div", null, parseJSONString(state.get('products'), []).map((product) => {
          return (h("div", { style: { display: 'flex' } }, h("button", { onClick: () => (this.productIdToShow = product.commercialReference) }, "Show CC for ", product.commercialReference), "-- Its price is ", h("pes-cc-price", { productId: product.commercialReference })));
        }), h("pes-cc-main", { host: state.get('host'), products: parseJSONString(state.get('products'), []), additionalDistributors: parseJSONString(state.get('additionalDistributors'), []), productIdToShow: this.productIdToShow, siteType: state.get('siteType'), localeCode: `${state.get('country')}/${state.get('language')}` })));
      case 'pesCatalog':
      default:
        return this.pesApp;
    }
  }
  render() {
    return (h(Host, { style: { display: 'block', 'padding-bottom': '40px' } }, this.app, this.showPanel && h("pes-settings-control-panel", null)));
  }
};
AppPlayground.style = appPlaygroundCss;

export { AppPlayground as pes_app_test };
